import { Injectable } from '@angular/core';
import { iBisAuthService } from '@dohu/ibis-auth';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { alert } from 'devextreme/ui/dialog';
import { iBisEditService, iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { Router } from '@angular/router';
import { DataService } from '../../../app/service/data.service';
import { forkJoin, from, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthDetailsService extends iBisEditService {

  public role: any;
  public specialization: any;
  public party: { id: string, name: string, role: any[], specialization: any[] }[];

  private ad: AuthDetails = new AuthDetails({ id: '', name: '' }, { id: '', name: '' }, [{ id: '', name: '' }]);
  public partyUserDataLoadedSubject = new ReplaySubject<any>(1)

  constructor(private entity: iBisEntityService, public lg: iBisLanguageService, public config: iBisServerConfig,
    public auth: iBisAuthService, protected router: Router, public ds: DataService) {
    super(lg);
    this.model = { partyId: null, roleId: null, specializationId: null, keepOption: true };
    this.validation = 'authDetailsValidation';
    this.title = 'Configureaza utilizator';
    this.checkPartyUser()
  }

  public get authDetails(): AuthDetails {
    return this.ad;
  }

  private checkPartyUser() {
    this.auth.onAuthFinished.subscribe(async resp => {
      //const result = await this.entity.execute('CheckPartyUser', {})
      //const result = []
      //console.log(this.auth)
      this.checkForPartyUserData(this.auth.user.id)
      //this.getRolesForUser({ partyId: 'a9decd85-148b-4c05-a164-eba0afe5f8aa', userId: this.auth.user.id }).then((res: any) => {
      //const existingConfig = JSON.parse(localStorage.getItem('authDetails-' + this.auth.user.id));
      // existingConfig.party.id = 'a9decd85-148b-4c05-a164-eba0afe5f8aa'
      // existingConfig.role.name = 'admin'
      //  existingConfig.specialization = [{ id: '10454824-b788-43c9-8911-1a0f618f3119', name: 'ORL' }]
      //this.ad.party = existingConfig ? { id: existingConfig['party'].id, name: existingConfig['party'].name } : { id: result[0].Item1, name: result[0].Item2 };
      //this.ad.role = existingConfig ? { id: existingConfig['role'].id, name: existingConfig['role'].name } : { id: result[0].Item3[0][0], name: result[0].Item3[0][1] };
      /*  if (result[0].Item4.length > 0) {
         result[0].Item4.forEach(element => {
           this.ad.specialization.push({ id: element[0], name: element[1] });
         });
       } */
      // this.ad.specialization.push(existingConfig.specialization)

      //this.partyUserDataLoadedSubject.next(true);
      //this.partyUserDataLoadedSubject.complete()
    });
  }

  public checkForPartyUserData(userId: string) {
    const q = new EntityQuery('Party')
      .linkEq('id', 'partyId', 'PartyUser', 'userId', userId)
    q.distinct = true;
    return this.entity.store(q, false, 'id').load().then((parties: any) => {
      const invent = parties.find(p => (p.name.includes('Invent')))
      this.party = [];

      const obs1 = from(this.getRolesForUser({ partyId: invent ? invent.id : parties[0].id, userId: userId }))
      const obs2 = from(this.getSpecializationForUser({ partyId: invent ? invent.id : parties[0].id, userId: userId }))
      const obs3 = from(this.getRolesInfo())
      const existingConfig = JSON.parse(localStorage.getItem('authDetails-' + this.auth.user.id));

      forkJoin([obs1, obs2, obs3]).subscribe(([partyRoles, specs, rolesData]) => {
        const rolesArray = rolesData as { id: string, name: string }[];
        this.ad.party = existingConfig ? { id: existingConfig['party'].id, name: existingConfig['party'].name } : invent ? { id: invent.id, name: invent.name } : { id: parties[0].id, name: parties[0].name };
        this.ad.role = existingConfig ? { id: existingConfig['role'].id, name: existingConfig['role'].name } : { id: partyRoles[0].roleId, name: rolesArray.find(rd => rd.id == partyRoles[0].roleId)?.name || '' };
        this.ad.specialization = []
        if (this.ad.role.name == 'doctor' && Array.isArray(specs) && specs.length > 0) {
          (specs as any[]).forEach(spec => {
            this.ad.specialization.push({ id: spec.specializationId, name: '' });
          });
        }
        parties.forEach(party => {
          this.party.push({
            id: party.id,
            name: party.name,
            role: (partyRoles as any[]).map((x: any) => { return { id: x.roleId, name: rolesArray.find(rd => rd.id == x.roleId)?.name || '' }; }),
            specialization: this.ad.specialization
          });
        });
        /*  console.log(partyRoles, 'partyRoles')
         console.log(specs, 'specs')
         console.log(rolesData, 'rolesData')
         console.log(this.ad)
         console.log(this.party) */
        this.partyUserDataLoadedSubject.next(true);
        this.partyUserDataLoadedSubject.complete()
      });
    });
  }

  public getRolesForUser(obj: any) {
    return new Promise((resolve, reject) => {
      const q = new EntityQuery('PartyUser').eq('partyId', obj.partyId).eq('userId', obj.userId).neq('roleId', null)
      this.entity.store(q).load().then((res: any) => {
        resolve(res)
      }, err => reject(err));
    });
  }

  public getRolesInfo() {
    return new Promise((resolve, reject) => {
      const q = new EntityQuery('UserLoginRole').addOrderBy(['name']);
      q.link('groupId', 'rolegroupid', new EntityQuery('ApplicationConfig')
        .linkEq('id', 'configId', 'Application', 'id', this.auth.companyId));
      this.entity.load(q, this.config.saasServer).then((res) => {
        resolve(res)
      }, err => reject(err));
    });
  }

  public getSpecializationForUser(obj: any) {
    return new Promise((resolve, reject) => {
      const q = new EntityQuery('UserSpecialization').eq('userId', obj.userId).eq('partyId', obj.partyId)
      this.entity.store(q).load().then((res: any) => {
        resolve(res)
      }, err => reject(err));
    });
  }

  onPartyChanged = (ev: any) => {
    if (ev.event || ev.value) {
      this.role = this.party.find(p => p.id == ev.value).role;
      this.specialization = this.party.find(s => s.id == ev.value).specialization
    }
  }

  onHide = () => {
    super.hidePopup();
    if (!localStorage.getItem('authDetails')) {
      this.popup.hide();
      this.auth.logout();
    }
  }

  createDefault() {
    return {};
  }
  getById(open: any, serverUrl?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const config: any = localStorage.getItem('authDetails-' + this.auth.user.id);
      const ur = config ? JSON.parse(config) : {};
      if (!this.entity) { return; }
      // showIF keepOption is false or dont have config
      if (!ur.keepOption || !config || open) {
        if (this.party && this.party.length) {
          resolve(this.getDefault(ur));
        } else {
          this.entity.execute('CheckPartyUser', {}).then(resp => {
            resolve(this.initPartyData(resp, ur));
          });
        }
      }
    });
  }
  onRemove(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  onSaveEv(serverUrl?: string): Promise<any> {
    return new Promise((resolve) => {
      const obj = {
        userId: this.auth.user.id,
        party: this.party.find(x => x.id == this.model.partyId),
        role: this.role.find(x => x.id == this.model.roleId),
        specialization: this.specialization.find(x => x.id == this.model.specializationId),
        keepOption: this.model.keepOption
      }
      //this.ds.authDetails = obj;
      this.ad.party = this.party.find(x => x.id == this.model.partyId);
      this.ad.role = this.role.find(x => x.id == this.model.roleId);
      this.ad.specialization = this.specialization.find(x => x.id == this.model.specializationId);
      this.onDataChanged.next('party-user-change')
      localStorage.setItem('authDetails-' + this.auth.user.id, JSON.stringify(obj));
      this.auth.displayRole = obj.role.name;
      this.redirectTo(this.router.url);


      // this.auth.displayRole = this.ad.role.name;
      resolve({});
      // in functie de role fac o rutare
      // assitentul se duce pe calendar
    })
  }
  reset(): void {
    throw new Error('Method not implemented.');
  }

  // prepare party data from server
  private initPartyData(data: any, ur?: any) {
    if (data.length === 0) {
      alert('Nu exista nici o clinica asociata cu acest user.', 'Alerta').then(resp => {
        this.hidePopup();
        this.auth.logout().then(() => {
          this.router.navigateByUrl('/login');
        });
      });
      return {};
    }
    this.party = [];
    for (const el of data) {
      this.party.push({
        id: el.Item1,
        name: el.Item2,
        role: el.Item3.map(item => ({ id: item[0], name: item[1] })) || [],
        specialization: el.Item4.map(item => ({ id: item[0], name: item[1] })) || []
      });
    }
    const obj = this.getDefault(ur);
    this.onPartyChanged({ value: obj.partyId });
    return obj;

  }
  private getDefault(ur: any) {
    return {
      partyId: ur?.party?.id || this.party[0].id,
      roleId: ur?.role?.id || this.party[0].role[0].id,
      specializationId: ur?.specialization?.id || (this.party ? this.party[0]?.specialization[0]?.id : null) || null,
      keepOption: (ur?.keepOption != undefined ? ur?.keepOption : true),
    }
  }
  private redirectTo(uri: string) {
    this.router.navigateByUrl('/scheduler', { skipLocationChange: true }).then(() =>
      this.router.navigateByUrl(uri));
  }
}

export class AuthDetails {
  party: { id: string, name: string };
  role: { id: string, name: string };
  specialization: { id: string, name: string }[] = [];

  constructor(party: { id: string, name: string }, role: { id: string, name: string }, specialization: [{ id: string, name: string }]) {
    this.party = party;
    this.role = role;
    this.specialization = specialization;
  }
}
